import styled from 'styled-components'
import { fadeUp } from '../styles'

const Form = styled.form`
    margin: 0;
    width: 100%;
    animation: ${fadeUp} 300ms linear;
    label {
        font-size: 14px;
        color: #081717;
        font-weight: 400;
        margin: 0 0 8px 0;
        display: block;
    }
    input {
        padding: 8px;
        box-sizing: border-box;
        background-color: #FCFCFC;
        font-size: 16px;
        border: 0.5px solid rgba(8,23,23,0.2);
        border-radius: 2px;
        display: block;
        width: 100%;
        margin-bottom: 32px;
    }
`

export default Form